import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRainbow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRainbow"><Path d="M0.5 18C0.5 11.6487 5.64873 6.5 12 6.5C18.3513 6.5 23.5 11.6487 23.5 18M3.5 18C3.5 13.3056 7.30558 9.5 12 9.5C16.6944 9.5 20.5 13.3056 20.5 18M6.5 18C6.5 14.9624 8.96243 12.5 12 12.5C15.0376 12.5 17.5 14.9624 17.5 18M9.5 18C9.5 16.6193 10.6193 15.5 12 15.5C13.3807 15.5 14.5 16.6193 14.5 18" stroke="currentColor"/></CentralIconBase>;
});

export default IconRainbow;
